/**
 * Change iWear — localStorage wishlist hearts (PLP + PDP)
 */
(function () {
  if (window.ciwWishlistInit) return;
  window.ciwWishlistInit = true;

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem('ciwWishlist') || '[]');
    } catch (e) {
      return [];
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ciw-card__heart');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    var list = readWishlist();
    var i = list.indexOf(id);
    if (i === -1) {
      list.push(id);
      btn.classList.add('is-saved');
      btn.setAttribute('aria-pressed', 'true');
    } else {
      list.splice(i, 1);
      btn.classList.remove('is-saved');
      btn.setAttribute('aria-pressed', 'false');
    }
    localStorage.setItem('ciwWishlist', JSON.stringify(list));
  });

  function restoreWishlist() {
    var list = readWishlist();
    document.querySelectorAll('.ciw-card__heart').forEach(function (btn) {
      var saved = list.indexOf(btn.getAttribute('data-product-id')) !== -1;
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  window.ciwRestoreWishlist = restoreWishlist;
  document.addEventListener('ciw:collection-updated', restoreWishlist);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreWishlist);
  } else {
    restoreWishlist();
  }
})();
